import React, { useState, useEffect } from "react";
import { getS3UrlFromKey } from "utils/common";
import boatImage from 'assets/images/boats/boat.jpg';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

export function ImageDisplay(props) {
    const { s3Key, classStyle, file, placeHolderImage = boatImage } = props;
    const [image, setImage] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (file) {
                console.log("file", file);
                setImage(URL.createObjectURL(file));
            }
            if (s3Key) {
                try {
                    const s3Url = await getS3UrlFromKey(s3Key);
                    setImage(s3Url);
                } catch (error) {
                    console.log("error===>>>>>", error);
                    setImage(placeHolderImage); // Set placeholder image on error
                }
            }
        };

        fetchData();
    }, [s3Key, file, placeHolderImage]);

    const getClassStyle = () => {
        return classStyle || "h-14 w-14 rounded-full ring-4 ring-white sm:h-14 sm:w-14";
    };

    return (
        <PhotoProvider maskOpacity={0.5}>
            <PhotoView src={image || placeHolderImage}>
                <img
                    className={getClassStyle()}
                    src={image || placeHolderImage}
                    alt=""
                    style={{ objectFit: 'cover' }}
                    onError={(e) => {
                        e.target.src = placeHolderImage; // Set placeholder image on error
                    }}
                />
            </PhotoView>
        </PhotoProvider>
    );
};